import { relations, sql } from 'drizzle-orm'
import {
  boolean,
  pgEnum,
  pgTable,
  text,
  uniqueIndex,
} from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes } from '../common/utils'
import { cashAccounts } from './cashAccount'
import { cashEvents } from './cashEvent'

// Which Fennoa tenant holds this company's invoices and ledger. The same two
// values the API client takes, so the credentials and the rows they produce
// name the same company instead of being matched by assumption.
export const fennoaCompanyEnum = pgEnum('fennoa_company', [
  'subsidiary',
  'parent',
])

// Legal entity for the finance module only. Not a tenant: operational tables
// (customers, visits, employees) never reference it.
export const companies = pgTable(
  'companies',
  {
    ...getBaseFields(),
    name: text().notNull(),
    businessId: text().notNull().unique(),
    isGroupParent: boolean().notNull().default(false),
    // Null for a company with no Fennoa of its own, so nothing imports into it.
    fennoaKey: fennoaCompanyEnum(),
    // The API user the credentials behind `fennoaKey` must authenticate as.
    // Fennoa's payloads name no tenant, so this is the only thing that can
    // catch one company's key sitting in the other's secret slot.
    fennoaUsername: text(),
  },
  (table) => [
    ...getBaseIndexes('companies', table),
    uniqueIndex('companies_fennoa_key_unique_idx')
      .on(table.fennoaKey)
      .where(sql`fennoa_key IS NOT NULL AND deleted_at IS NULL`),
  ],
)

export const companiesRelations = relations(companies, ({ many }) => ({
  cashAccounts: many(cashAccounts),
  cashEvents: many(cashEvents),
}))
